import { FormState, useWatch } from '@vtex/admin-ui-form'
import {
  FormAliasKeys,
  useFormAlias,
} from '../ui/providers/useFormAlias.constate'
import { useMemo } from 'react'

type Props = {
  key: FormAliasKeys
  form: FormState
}

export function useWatchAlias<T>(props: Props) {
  const { key, form } = props

  const { getAlias } = useFormAlias()

  const alias = getAlias(key)

  const watchValue: T | undefined = useWatch({
    form,
    name: alias ?? '',
  })

  const value: T | undefined = useMemo(() => {
    if (watchValue === undefined) return form.getValues(alias ?? '')
    return watchValue
  }, [alias, form, watchValue])

  return value
}
